import React from 'react';
// import { useNavigate } from 'react-router-dom';
import { useSelector } from "react-redux";
// import { portalActions } from "../../store/portal-slice";
// import { getLocalStore, setLocalStore } from "helpers/localStoreSrv";
// import whitelabelConfig from "@whitelabel-config";
// import { useUiState } from "helpers/useUiState";
import { useApi } from "helpers/useApi";
// import api from "helpers/api";
export const useProfilePageSrv = () => {
    // const { isAppLoading } = useUiState();
    // const dispatch = useDispatch();
    const { api } = useApi();
    const portalSessionMeta = useSelector((state: any) => state.portal.micrositeSession);
    console.log("portalSessionMeta", portalSessionMeta)
  
    const httpgetMember = () => {
        console.log("portalSessionMeta ww", portalSessionMeta)
        return api.get('/api/member')
        
    }
    const httpgetDocument = () => {
            return api.get('/api/document')
    }

  
  
    return {  httpgetMember, httpgetDocument }
}